import React from 'react';
import cn from 'classnames';

import { Icons } from '@icons/icons';

import { useAppDispatch } from '@store/store';

import { removeAssociatedTask } from '@slices/portalMilestones';

import { IPortalTaskToLinkDTO } from '@interfaces/portal/dto/taskManagementDTO';

import styles from './AssociatedTaskItem.module.scss';

interface IAssociatedTaskItemProps {
	associatedTask: IPortalTaskToLinkDTO;
	isViewMode: boolean;
}

const AssociatedTaskItem = ({
	associatedTask,
	isViewMode,
}: IAssociatedTaskItemProps) => {
	const dispatch = useAppDispatch();

	const { id, taskId, title } = associatedTask;

	const removeAssociatedTaskHandler = () => {
		dispatch(removeAssociatedTask({ id }));
	};

	const associatedTaskStyles = cn(styles.associatedTaskContainer, {
		[styles.viewMode]: isViewMode,
	});

	return (
		<div className={associatedTaskStyles}>
			<div className={styles.taskTitle}>
				{`${taskId} ${title}`}
			</div>
			{!isViewMode
				&& <div
					className={styles.removeIcon}
					onClick={removeAssociatedTaskHandler}
				>
					{Icons.removeIcon()}
				</div>
			}
		</div>
	);
};

export default AssociatedTaskItem;
